import { GET_APPLICATION_FORM_DETAILS_ACTION_TYPE, INSERT_UPDATE_APPLICATION_FORM_ACTION_TYPE,GET_APPLICATION_FORM_DEFAULT_DETAILS_ACTION_TYPE,GET_APPLICANT_PRICING_ACTION_TYPE } from "../../utils/constants";

const initialState = [];
function applicationForm_Reducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case GET_APPLICATION_FORM_DEFAULT_DETAILS_ACTION_TYPE:
            return [...state, payload];
        case GET_APPLICATION_FORM_DETAILS_ACTION_TYPE:
            return [...state, payload];
        case GET_APPLICANT_PRICING_ACTION_TYPE:
            return [...state, payload];
        case INSERT_UPDATE_APPLICATION_FORM_ACTION_TYPE:
            return [...state, payload];
        default:
            return state;
    }
}
export default applicationForm_Reducer;
